import { axiosModules } from "@qubit-utill/src";

export default {
  getWordCloudData: (termsTab, params) => {
    return axiosModules.get(termsTab === "day" ? `/pstats/actiondetect/day/word` : `/pstats/actiondetect/${termsTab}`, params);
  },
  getHeatMapData: (params) => axiosModules.get(`/pstats/actiondetect/day`, params),
  getHeatMapList: (params) => axiosModules.get(`/pstats/actiondetect/day/list`, params),
};
